export default {

    images: [
        {
          src: require(`@/assets/home_carousel_images/tmak_overview.png`),
        },
        {
          src: require(`@/assets/home_carousel_images/a2_3project.png`),
        },
        {
          src: require(`@/assets/home_carousel_images/a2_spec.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/small_group.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/multimodal_fb.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/multimodal_emo.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/lifestyle_ana.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/stress_estimate1.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/stress_estimate2.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/stress_estimate3.png`),
        },
        {
            src: require(`@/assets/home_carousel_images/vr_emo_estimate.png`),
        },
        {
          src: require(`@/assets/home_carousel_images/uda.png`),
        },
        {
          src: require(`@/assets/home_carousel_images/oga.png`),
        },
        {
          src: require(`@/assets/home_carousel_images/hayamichi.png`),
        },
        {
          src: require(`@/assets/home_carousel_images/mori.png`),
        },
    ]
}